"use client"
import { AppChannel } from "@/config/channel"
import { useConfigParams } from "@/hooks/use-config-params"
import { EventName, useCustomEvent } from "@/hooks/use-custom-event"
import { useCustomSearchParams } from "@/hooks/use-search-params"
import useGlobalParamsStore from "@/store/global-params-store"

export function BeforeUnloadPopup() {
  /*------------------------------hooks------------------------------*/
  const { jwt, hasInformationDisplayBeenVisited, setOutgoingUrl } =
    useGlobalParamsStore()
  const [, setSearchParams] = useCustomSearchParams()
  const { channel } = useConfigParams()

  /*------------------------------helpers------------------------------*/

  function isPopupEnabled() {
    if (channel === AppChannel.AppSisalPoker) return false

    const allowedCountries = ["PT", "ES"]

    if (!allowedCountries.includes(window.APP_COUNTRY)) return false

    const isAuthTokenPresent = typeof jwt === "string" && jwt.length > 0
    if (!isAuthTokenPresent) return false

    if (hasInformationDisplayBeenVisited) return false

    return true
  }

  useCustomEvent<{ url: string | URL }>({
    eventName: EventName.PostLoginRedirect,
    onSignal(e) {
      setOutgoingUrl(e.detail.url)
      if (isPopupEnabled()) {
        return setSearchParams((prevParams) => {
          prevParams.set("informationDisplay", "open")
          return prevParams
        })
      }

      window.location.assign(e.detail.url)
    },
  })

  return null
}
